// extracted by mini-css-extract-plugin
export default {"shadowed":"About_shadowed__hsjml","pink":"About_pink__PEb4I","green":"About_green__Mih4Z","skills":"About_skills__RvndN"};